import React from 'react';

export default function AstronautFishbowlSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient id="fishbowlGlass" cx="0.35" cy="0.3" r="0.75">
          <stop offset="0%" stopColor="#FFFFFF" stopOpacity="0.5" />
          <stop offset="60%" stopColor="#B3E5FC" stopOpacity="0.18" />
          <stop offset="100%" stopColor="#E1F5FE" stopOpacity="0.25" />
        </radialGradient>
      </defs>
      {/* Collar ring (bottom) */}
      <ellipse cx="20" cy="33" rx="13" ry="3.5" fill="#CFD8DC" />
      <ellipse cx="20" cy="32.5" rx="12" ry="2.5" fill="#ECEFF1" />
      {/* Glass dome - outer outline */}
      <ellipse cx="20" cy="20" rx="15" ry="14" fill="white" opacity="0.15" stroke="#B0BEC5" strokeWidth="1.2" />
      {/* Inner glass shading */}
      <ellipse cx="20" cy="20" rx="14" ry="13" fill="url(#fishbowlGlass)" />
      {/* Highlight reflections */}
      <path d="M9 14 C11 10 16 7 22 9" stroke="white" strokeWidth="1.8" strokeLinecap="round" fill="none" opacity="0.7" />
      <path d="M8 20 C9 17 11 15 13 14" stroke="white" strokeWidth="1" strokeLinecap="round" fill="none" opacity="0.45" />
      {/* Small glass shine dot */}
      <circle cx="27" cy="14" r="1.2" fill="white" opacity="0.6" />
      <circle cx="24" cy="26" r="0.7" fill="white" opacity="0.4" />
      {/* Collar bolts */}
      <circle cx="9" cy="33" r="1.2" fill="#90A4AE" />
      <circle cx="31" cy="33" r="1.2" fill="#90A4AE" />
      {/* Top oxygen valve */}
      <rect x="18.5" y="4" width="3" height="3" rx="0.5" fill="#B0BEC5" />
      <circle cx="20" cy="3" r="1.2" fill="#78909C" />
    </svg>
  );
}
